import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { urjanetServiceRoutes } from './routes';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
export class Urjanet {
  constructor() {
    _defineProperty(this, "routes", urjanetServiceRoutes);
  }
  async patchAccount(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).patch(this.routes.accountUrlId(data.urjanetId), {
      livablePropertyUtilityId: data.livablePropertyUtilityId
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCredentials(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).post(this.routes.credentialsUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putCredentials(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).put(this.routes.credentialsUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCredentials(options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).get(this.routes.credentialsUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteCredentials(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).delete(this.routes.credentialsIdUrl(data.id), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCredentialProviders(options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).get(this.routes.credentialProvidersUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getProviderStatements(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.URJANET).get(this.routes.providerStatementsPreviewUrl(data.livableProviderId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}